module.exports = __webpack_public_path__ + "static/media/hotlink.8028edde.png";